import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import { Reveal, Tween } from "react-gsap";
import SmartText from "../../utils/TextHandler";
import SmartImage from "../../utils/ImageHandler";
import SmartColour from "../../utils/ColourHandler";
import SocialLinks from "../Global/SocialLinks";
import Title from "../Title/Title";
import CardSignature from "../Cards/CardSignature";

const SectionSignatures = (props) => {
  const { items } = props;

  if (items.length > 0) {
    return (
      <section className="py-5 brand-background-yellow">
        <div className="container">
          <Title title="Buy Now" accent="black" colour="black" />
          <div className="row gy-5 justify-content-start">
            <>
              {items.map((node, index) => {
                const item = node;
                const delay = (1 * index) / 10;

                return (
                  <Tween
                    from={{ x: "300px", opacity: 0 }}
                    duration={0.75}
                    delay={delay}
                    ease="back.out(1.5)"
                  >
                    <div className="col-6 col-md-3">
                      <CardSignature item={item} />
                    </div>
                  </Tween>
                );
              })}
            </>
          </div>
        </div>
      </section>
    );
  }
  return null;
};

export default SectionSignatures;
